// دالة مساعدة لتوليد الاهتزاز التفاعلي
export const triggerHaptic = (style = 'light') => {
  const tg = window.Telegram?.WebApp;
  if (tg?.HapticFeedback) {
    if (style === 'error') {
      tg.HapticFeedback.notificationOccurred('error');
    } else if (style === 'success') {
      tg.HapticFeedback.notificationOccurred('success');
    } else {
      tg.HapticFeedback.impactOccurred(style); // 'light' | 'medium' | 'heavy'
    }
  }
};
